var _path, _path2, _stop, _stop2, _stop3, _stop4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgNotFoundBiteLogo(props) {
  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.67 4.517c4.319 0 7.82 3.68 7.82 8.22 0 4.537-3.498 8.216-7.816 8.22-4.318-.004-7.818-3.682-7.821-8.22h-.005c0-4.54 3.501-8.22 7.821-8.22z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.356.663h-20.3a.944.944 0 00-.584.336l-.29.273c-.026.151-.04.305-.04.459 0 1.809 1.93 1.99 1.93 1.99 1.11.277 1.875 1.348 1.818 2.546 0 .22-.021.437-.066.651a2.64 2.64 0 00-.264 1.116c0 1.425 1.523 1.91 1.523 1.91.829.4 1.356 1.274 1.346 2.232 0 .441-.09.877-.259 1.28a2.37 2.37 0 00-.508 1.394c0 1.174 1.179 1.841 1.179 1.841.57.46.908 1.167.919 1.921a3.26 3.26 0 01-.559 1.74 2.103 2.103 0 00-.817 1.602 2.61 2.61 0 00.817 1.713c.358.45.56 1.014.574 1.601a3.048 3.048 0 01-.93 2.082c-.68.288-1.133.974-1.152 1.745.022.539.2 1.058.508 1.489.182.384.28.805.29 1.233 0 1.494-1.377 2.29-1.377 2.29-1.219.384-1.524 1.2-1.524 1.89.006.392.086.78.234 1.141.06.25.091.506.091.764 0 1.878-1.843 2.45-1.843 2.45-1.646.111-1.93 1.296-1.93 2.044-.001.19.016.379.05.565l.26.246c.17.167.384.277.614.315h20.295c6.407.022 11.618-5.417 11.639-12.15.011-3.576-1.472-6.976-4.056-9.301 4.847-4.398 5.383-12.092 1.198-17.186C42.94 2.203 39.736.663 36.367.663h-.01zm.701 3.65c4.32 0 7.822 3.681 7.822 8.22 0 4.538-3.499 8.217-7.817 8.22-4.318-.003-7.818-3.681-7.821-8.22h-.005c0-4.539 3.501-8.22 7.821-8.22z",
    fill: "url(#".concat(_id2, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.966 12.474c0-1.48-1.162-2.678-2.595-2.678a2.52 2.52 0 00-1.32.372c.196.182.32.445.32.738 0 .547-.429.99-.958.99a.933.933 0 01-.534-.168 2.763 2.763 0 00-.102.746c0 1.48 1.162 2.679 2.594 2.679 1.433 0 2.595-1.2 2.595-2.679z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.458 26.955l9.043-2.173 2.29-15.091 4.316-3.553M20.993 26.955l-9.043-2.173L9.66 9.691 5.344 6.138",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 49.468,
    y1: 8.65,
    x2: 41.294,
    y2: 0.697,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 15.462,
    y1: 0.301,
    x2: 15.462,
    y2: 42.56,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600DB"
  })))));
}

export default SvgNotFoundBiteLogo;